import React from "react";
import {Link as RouterLink, useParams} from "react-router";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";

export default function Section({ title, step, children }) {
  const { section } = useParams();
  const selected = section === step;

  return (
    <Paper>
      <Box p={3}>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="h3" color="textSecondary">
            {title}
          </Typography>
          {!selected && (
            <Link className="unfocus" to={`/shopping/cart/${ step }`} component={RouterLink}>
              Change
            </Link>
          )}
        </Box>
        {children}
      </Box>
    </Paper>
  );
}
